module.exports = __webpack_public_path__ + "static/media/service-panels-1.dc689445.jpg";